export default __webpack_public_path__ + "static/media/upload-success.f1813664.svg";